import api from "@/utils/axios";
import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    token: null as string | null,
    user: null as Record<string, any> | null,
    permissions: [] as string[], // ✅ explicitly typed

  }),

  actions: {
    setToken(token: string) {
      this.token = token;
    },
    setUser(user: Record<string, any>) {
      this.user = user;
    },
    clearAuth() {
      this.token = null;
      this.user = null;
      this.permissions = []
    },

    setPermissions(permissions: Record<string, any>) {
      this.permissions = Object.keys(permissions).filter(key => permissions[key])
    },

    async fetchPermissions() {
      try {
        if(this.user){
          const { data } = await api.get(`/api/auth/get_perms_user/${this.user?.id}`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          })
          // normalize permissions to an array
          console.log("callperms check")
          this.permissions = data || []  
        }
        
      } catch (error) {
        console.error('Failed to fetch permissions:', error)
        this.permissions = []
      }
    },

    can(key : string) {
      return this.permissions.includes(key)
    },
    


  },

  persist: true, // 🔥 persist in localStorage
});
